import { OptionsSortType } from 'Core/interfaces'

import { OPTIONS_SORT_CONFIG } from './constants'

export const sortOptions = ({
	options,
	sortType
}: {
	options: MainSearchOptions[]
	sortType: OptionsSortType
}): MainSearchOptions[] => {
	const sortCallback = OPTIONS_SORT_CONFIG[sortType]

	return sortCallback(options)
}
